module.exports = __webpack_public_path__ + "static/media/angular-brands.eb35c03e.svg";